/* unplugin-vue-components disabled */import { render } from "./idle-logout.vue?vue&type=template&id=7faa5e08&scoped=true"
import script from "./idle-logout.vue?vue&type=script&lang=js"
export * from "./idle-logout.vue?vue&type=script&lang=js"

import "./idle-logout.vue?vue&type=style&index=0&id=7faa5e08&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7faa5e08"]])

export default __exports__